export const getCopyright = (): string => {
	return `\u00A9 2016–${new Date().getFullYear()} Elsewhere`;
};
